import { FunctionalComponent, h } from '@stencil/core'

export const ProgressLine: FunctionalComponent<{ percent: number }> = ({ percent }) => {
  if (!percent || percent <= 0) {
    // Nice try
    return
  }

  // Good one, actually
  percent = Math.min(percent, 100)

  return (
    <div class='flex flex-row items-start w-full'>
      <div class='h-1 bg-brand' style={{ width: percent + '%' }}>
        &nbsp;
      </div>
    </div>
  )
}
